import Vue from 'vue';
import Vuex from 'vuex';
import { categories, team } from '@/assets/data';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    subMeunSwitch: false,
    aboutSection2IsPlayed: false,
    aboutSection4IsPlayed: false,
    d2AboutTheme: 'white',
    productCategory: null,
    members: null,
    mobileMemberDetailShow: false,
    goindex: null,
  },
  mutations: {
    setCategory(state, data) {
      state.productCategory = data;
    },
    setMembers(state, data) {
      state.members = data;
    },
    setForward(state, data) {
      state.goindex = data;
    },
  },
  actions: {
    getCategories({ state, commit }) {
      return new Promise((resolve) => {
        if (state.productCategory === null) {
          categories().then((res) => {
            commit('setCategory', res.data);
            resolve();
          });
        } else {
          resolve();
        }
      });
    },
    getMembers({ state, commit }) {
      return new Promise((resolve) => {
        if (state.members === null) {
          team().then((res) => {
            commit('setMembers', res.data);
            resolve();
          });
        } else {
          resolve();
        }
      });
    },
  },
  getters: {
    member: (state) => (id) => {
      if (state.members) {
        return state.members.find((item) => Number(item.id) === Number(id));
      }
      return null;
    },
  },
  modules: {
  },
});
